module.exports = __webpack_public_path__ + "static/media/clock.8618178a.svg";